angular.module('angus.controllers').controller('growthToBudgetSettingsController', [
    '$scope', '$rootScope', '$http',
    function($scope, $rootScope, $http) {

    }
]);